"use client";

import React from "react";
import { Fragment, useRef } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
  TransitionChild,
} from "@headlessui/react";
import Image from "next/image";

export default function GavelModal({
  openModal,
  setOpenModal,
  gavelFileName,
  villaName
}) {
  const cancelButtonRef = useRef(null);
  return (
    <Dialog open={openModal} onClose={setOpenModal} className="relative z-[55]">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 overflow-y-auto">
        <div className="flex items-center justify-center min-h-full p-4 text-center sm:p-0">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel className="relative w-full overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:max-w-xl md:max-w-2xl lg:max-w-5xl">
              <DialogTitle className="flex items-center justify-between flex-1 p-4">
                <span className="flex-1 block text-xl font-bold text-center text-darkYellow-100">
                  {villaName}
                </span>
                <button
                  onClick={() => {
                    setOpenModal(false);
                  }}
                  ref={cancelButtonRef}
                >
                  <Image
                    src="/icons/close.svg"
                    alt="close"
                    width={20}
                    height={20}
                  />
                </button>
              </DialogTitle>
              <iframe width="100%" height="500" src={gavelFileName} />
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  );
}
